module.exports = __webpack_public_path__ + "static/media/cardAdd.ce60844d.svg";